import React, { useState } from 'react'
import * as Types from 'types'
import { isEmpty } from 'lodash'
import PropTypes from 'prop-types'
import { ImageCarousel } from 'components'

const propTypes = {
  program: Types.program.isRequired,
  isTeachingArtist: PropTypes.bool,
  /** When true, show "View Program Photos" when program has images. Set from community config (e.g. teachingArtist.programPhotoEnabled or partnerProgramPhotoEnabled). */
  programPhotosEnabled: PropTypes.bool,
}

const defaultProps = {}

const displayTypes = (types, separator = ', ') => {
  if (isEmpty(types)) return <i>Information Not Provided</i>
  return types
    .map(({ displayName }) => displayName)
    .sort()
    .join(separator)
}

const displayGradeRange = (programGrades) => {
  if (isEmpty(programGrades)) return <i>Information Not Provided</i>

  const [first, second] = programGrades

  const idKey = !first?.gradeId ? 'id' : 'gradeId'

  return first[idKey] === second[idKey]
    ? first.displayName
    : `${first.displayName} - ${second.displayName}`
}

function ProgramBlock({
  program: {
    id,
    name,
    description,
    subDisciplines,
    financialAssistanceTypes,
    outcomes,
    approaches,
    programGrades,
    programTypes,
    minGrade,
    maxGrade,
    languages,
    programImages,
  },
  isTeachingArtist,
  programPhotosEnabled,
}) {
  const [showPhotosModal, setShowPhotosModal] = useState(false)
  const hasPhotos = !isEmpty(programImages)
  const showProgramPhotosBtn = hasPhotos && programPhotosEnabled
  const hasHTML = /<\/?[a-z][\s\S]*>/i.test(description)

  return (
    <div key={id} className="banner-block program-block card">
      <div className="text-block program-block-header">
        <h3>{name}</h3>
        {showProgramPhotosBtn && (
          <button
            type="button"
            className="button-secondary program-photos-btn"
            onClick={() => setShowPhotosModal(true)}
          >
            View Program Photos
          </button>
        )}
      </div>
      {hasHTML ? (
        <div
          className="ql-editor"
          dangerouslySetInnerHTML={{ __html: description }}
        />
      ) : (
        <p>{description}</p>
      )}
      <div className="outcomes-block">
        <p>
          <strong>Program Type(s): </strong>
          {displayTypes(programTypes)}
        </p>
        <p>
          <strong>Sub Disciplines: </strong>
          {displayTypes(subDisciplines)}
        </p>
        <p>
          <strong>Qualities & Intended Outcomes: </strong>
          {displayTypes(outcomes)}
        </p>
        <p>
          <strong>Approaches: </strong>
          {displayTypes(approaches)}
        </p>
        {!isEmpty(languages) && (
          <p>
            <strong>Languages: </strong>
            {displayTypes(languages)}
          </p>
        )}
        {!isTeachingArtist && (
          <>
            <p>
              <strong>Financial Support: </strong>
              {displayTypes(financialAssistanceTypes)}
            </p>
            <p>
              <strong>Program Grade Range: </strong>
              {displayGradeRange(programGrades)}
            </p>
          </>
        )}
        {isTeachingArtist && (
          <p>
            <strong>Program Grade Range: </strong>
            {displayGradeRange([minGrade, maxGrade])}
          </p>
        )}
      </div>
      {showPhotosModal && (
        <ImageCarousel
          autoPlay={false}
          images={programImages}
          modalImagesPerPage={2}
          modalOnly
          onClose={() => setShowPhotosModal(false)}
        />
      )}
    </div>
  )
}

ProgramBlock.propTypes = propTypes
ProgramBlock.defaultProps = defaultProps

export default ProgramBlock
